/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import useStyles from 'isomorphic-style-loader/useStyles';
import { useQuery, gql } from '@apollo/client';
import classNames from 'classnames';

// app modules: components
import HomeConnectPromoInfo from 'components/HomeConnectPromoInfo';

// assets
import CssCollectionsEditorial from './CollectionsEditorial.scss';

const COLLECTIONS_GROUP_QUERY = gql`
  query GetCollectionsGroup($tag: String) {
    CollectionsGroup(tag: $tag) {
      hero
      hero_content_html
      homeconnect
      href
      html
      id
      logo
      title
    }
  }
`;

export default function CollectionsEditorial(props) {
  const { tag } = props;
  useStyles(CssCollectionsEditorial);

  const { data } = useQuery(COLLECTIONS_GROUP_QUERY, {
    variables: {
      tag,
    },
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
  });

  if (data && data.CollectionsGroup) {
    return (
      <div className="collections-editorial">
        {data.CollectionsGroup.hero ? (
          <div className="collections-editorial__hero-wrapper">
            <img className="collections-editorial__hero" src={data.CollectionsGroup.hero} alt="" />

            {data.CollectionsGroup.hero_content_html ? (
              <div className="collections-editorial__hero-content-wrapper">
                <div
                  className="collections-editorial__content collections-editorial__hero-content"
                  dangerouslySetInnerHTML={{
                    __html: data.CollectionsGroup.hero_content_html,
                  }}
                />
              </div>
            ) : null}
          </div>
        ) : null}
        <div className="in-column margin-top-20">
          {data.CollectionsGroup.logo ? (
            <img
              className="collections-editorial__logo"
              src={data.CollectionsGroup.logo}
              alt="Logo"
            />
          ) : null}
          {data.CollectionsGroup.homeconnect ? <HomeConnectPromoInfo brand={tag} /> : null}
          <div
            className={classNames('collections-editorial__content', {
              'collections-editorial__content--match-hero': !!data.CollectionsGroup
                .hero_content_html,
            })}
            dangerouslySetInnerHTML={{
              __html: data.CollectionsGroup.html,
            }}
          />
        </div>
      </div>
    );
  }
  return null;
}

CollectionsEditorial.propTypes = {
  tag: PropTypes.string.isRequired,
};
